export default [
  {
    path: "/surgery",
    name: "surgery",
    component: () => import("@/views/surgery/Surgery.vue"),
  },
  {
    path: "/surgery/doctors",
    name: "doctor-surgery",
    component: () => import("@/views/surgery/DoctorSurgery.vue"),
  },
  {
    path: "/surgery/patients",
    name: "patient-surgery",
    component: () => import("@/views/surgery/PatientSurgery.vue"),
  },

  {
    path: "/patient-surgery-info/:id",
    name: "patient-surgery-info",
    component: () => import("@/views/surgery/PatientSurgeryInfo.vue"),
  },
  {
    path: "/add-patient-surgery/:id",
    name: "add-patient-surgery",
    component: () => import("@/views/surgery/AddPatientSurgeryInfo.vue"),
  },
  {
    path: "/consumables",
    name: "consumables",
    component: () => import("@/views/surgery/Consumables.vue"),
  },
  {
    path: "/dispense-consumable",
    name: "surgery-dispense-consumable",
    component: () => import("@/views/surgery/DispenseConsumable.vue"),
  },
  {
    path: "/add-patient-surgery-consumables/:id",
    name: "add-patient-surgery-consumables",
    component: () => import("@/views/surgery/AddConsumables.vue"),
  },
  {
    path: "/surgery-patient-history",
    name: "surgery-patient-history",
    component: () => import("@/views/surgery/SurgeryPatientHistory.vue"),
  },
  {
    path: "/surgery-patient",
    name: "surgery-patient",
    component: () => import("@/views/surgery/SurgeryPatient.vue"),
  },
];
